import { Link } from 'react-router-dom';
import { listSchemas } from '../engine/registry';

export default function AssessmentsIndex() {
  const schemas = listSchemas();
  return (
    <article>
      <h1 className="font-serif text-3xl">Free InnovateX assessments</h1>
      <p className="mt-2 text-muted">Scored, private, and emailed back to you within a minute.</p>
      <ul className="mt-8 grid gap-4 md:grid-cols-2">
        {schemas.map((s) => (
          <li key={s.id} className="rounded border border-border p-4">
            <h2 className="font-serif text-xl">
              <Link to={`/${s.slug}/`} className="text-brand hover:text-brand-dark">
                {s.title}
              </Link>
            </h2>
            <p className="mt-1 text-sm text-muted">
              {s.estimatedMinutes} min · {s.questions.length} questions
            </p>
            <p className="mt-2">{s.description}</p>
          </li>
        ))}
      </ul>
    </article>
  );
}
